export default __webpack_public_path__ + "static/media/bg-login-flexge.87da5a0d.png";